/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

/**
 * Paging arithmetic for a card.
 *
 * Cards hold a fixed number of rows. Anything longer pages inside the card
 * rather than making it taller than the one beside it.
 */

/** The page sizes a full-page list offers; the first is the default. */
export const PAGE_SIZES = [25, 50, 100] as const;

/** How many rows a card holds before it pages. */
export const PER_CARD = 5;

export function pageCount(total: number, per = PER_CARD): number {
  return Math.max(1, Math.ceil(total / per));
}

/** The page a table is actually on, clamped to what exists. */
export function pageOf(page: number, total: number, per = PER_CARD): number {
  return Math.min(Math.max(0, page), pageCount(total, per) - 1);
}

export function pageSlice<T>(rows: T[], page: number, per = PER_CARD): T[] {
  const current = pageOf(page, rows.length, per);
  return rows.slice(current * per, (current + 1) * per);
}
